
$(document).ready(function () {

  $('.dropdown-menu.active, .grandchild-dropdown.active').show();

  $(document).on('click', '.has-dropdown', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $this = $(this);
    var $dropdown = $this.next('.dropdown-menu, .grandchild-dropdown');

    var isActive = $dropdown.hasClass('active');

    var $parentWrapper = $this.closest('.dropdown-menu, body');


    if (!isActive) {
      $parentWrapper.find('.dropdown-menu, .grandchild-dropdown').not($dropdown).slideUp().removeClass('active');
      $parentWrapper.find('.has-dropdown').not($this).removeClass('active-link');
    }

    $this.toggleClass('active-link', !isActive);
    $dropdown.stop(true, true).slideToggle().toggleClass('active', !isActive);
  });


});
